module.exports = __webpack_public_path__ + "54cf98f5/img/settings-ico.a214628d.svg";